import React from 'react';
import { Form, Upload, Icon } from 'antd';

const { Item: FormItem } = Form;
const { Dragger } = Upload;

const normFile = (e) => {
  if (Array.isArray(e)) {
    return e.slice(-1);
  }
  return e && e.fileList.slice(-1);
};

const normFiles = (e) => {
  if (Array.isArray(e)) {
    return e;
  }
  return e && e.fileList;
};

const UploadField = ({
  form,
  label,
  className,
  name,
  rules,
  uploadProps = {},
  initialValue,
  disabled,
  disabledText = 'чтобы добавить документы измените статус счетчика',
}) => {
  const { getFieldDecorator } = form;

  return (
    <FormItem
      label={label}
      colon={false}
      className={className}
    >
      {getFieldDecorator(name, {
        valuePropName: 'fileList',
        getValueFromEvent: uploadProps.multiple ? normFiles : normFile,
        initialValue: initialValue || [],
        rules,
      })(
        <Dragger
          name="files"
          beforeUpload={() => false}
          {...uploadProps}
          disabled={disabled}
        >
          <Icon
            type="file-add"
            theme="outlined"
          />{' '}
          {disabled
            ? disabledText
            : 'перетащите файл или нажмите, чтобы выбрать'}
        </Dragger>
      )}
    </FormItem>
  );
};

export default UploadField;
